export default __webpack_public_path__ + "static/media/ic_done_all_48px.9361c23b.svg";